var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-carousel"},[_c('CtaHeading',{attrs:{"title":_vm.title,"level":2,"link":_vm.link,"linkText":_vm.linkText}}),_vm._v(" "),_c('SfLoader',{class:{ loading: _vm.loading },attrs:{"loading":_vm.loading}},[_c('AgCarousel',{staticClass:"carousel",attrs:{"settings":{
                peek: 16,
                gap: 20,
                breakpoints: {
                    1023: { peek: 0, perView: 3 },
                    767: { peek: 0, perView: 2 },
                    450: {
                        perView: 1,
                        peek: {
                            before: 0,
                            after: 150,
                        },
                    },
                },
            },"count":_vm.productsCount}},_vm._l((_vm.products),function(product){return _c('SfCarouselItem',{key:product.sku,staticClass:"carousel__item"},[_c('ProductCard',{attrs:{"product":product,"show-actions":true,"delivery-swatch-data":_vm.deliverySwatchData,"cart":_vm.cart}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }